export const GMStatuses = ['turquoise', 'silver', 'gold', 'platinum'];
